import { Component, OnInit, ElementRef, ViewChild, Input, Output, EventEmitter } from '@angular/core';

import { translationHelper } from '~/helpers/translation.helper';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';
import { uiHelper } from '~/helpers/ui.helper';
import { CoreService } from '~/legacy/ts/services/core.service';

declare let $;

declare let SetLanguage: any;

@Component({
    selector: 'comp_barcode_card_modal',
    templateUrl: './barcodecard-modal.html',
})
export class BarcodeCardModal implements OnInit {
    public Input_1_Value = '';
    public Input_2_Value = '';
    public Focused_Input = 'Input_1';

    Barcode = '';
    CustomerId = 0;
    IsFirst = true;
    IsBarcodeCard = false;
    ResultCode = 0;
    ResultMessage = '';
    ResultMessage2 = '';

    constructor(
        public tournamentsService: TournamentsService,
        public _translate: translationHelper,
        private _uiHelper: uiHelper,
        private _coreService: CoreService,
    ) {
        SetLanguage('', '');

        this._uiHelper.barcodeCardModalEventListener.subscribe((x: any) => {
            this.CustomerId = x.CustomerId;
            this.IsFirst = x.IsFirst;
            this.ResultCode = x.ResultCode;
            this.Barcode = x.Barcode;
            this.IsBarcodeCard = x.IsBarcodeCard;

            if (this.ResultCode == -1) {
                this.ResultMessage2 = 'PINError';
            }

            if (x.IsFirst == false) {
                this.onFocusEvent('Input_1');
            }
        });
    }

    ngOnInit() {
        SetLanguage('', '');
    }

    onFocusEvent(e) {
        // console.warn('ON FOCUS', e);
        this.Focused_Input = e;
    }

    public BarcodeCard_ChangeValue(e) {
        if (this.Focused_Input == 'Input_1') {
            this.Input_1_Value += e;
        } else {
            this.Input_2_Value += e;
        }
    }

    public ModalClose() {
        this.Input_1_Value = '';
        this.Input_2_Value = '';
        $('#BarcodeCardModal').modal('hide');
    }

    // Silme Tuşu
    public SettingLogin__Cancel() {
        if (this.Focused_Input == 'Input_1') {
            this.Input_1_Value = this.Input_1_Value.slice(0, -1);
        } else {
            this.Input_2_Value = this.Input_2_Value.slice(0, -1);
        }
    }

    public BarcodeCardOk() {
        let PIN1 = 0;
        if (this.Input_1_Value != '') {
            PIN1 = Number(this.Input_1_Value);
        }

        let PIN2 = 0;
        if (this.Input_2_Value != '') {
            PIN2 = Number(this.Input_2_Value);
        }

        if (this.IsFirst) {
            this.tournamentsService.ProcCustomerBarcodePINChangeResult(this.Barcode, PIN1, PIN2).then((x: any) => {
                this.ResultCode = x.ResultCode;
                this.ResultMessage = x.ResultMessage;

                if (x.ResultCode == 100) {
                    this._uiHelper.CloseBarcodeCardModal();
                    this.ProcCustomerBarcodeSearchTerminalResult(this.Barcode);
                }
            });
        } else {
            this.tournamentsService.ProcCustomerBarcodeLoginResult(this.Barcode, PIN1).then((x: any) => {
                // console.log('ProcCustomerBarcodeLoginResult',x);
                this.ResultCode = x.ResultCode;
                this.ResultMessage = x.ResultMessage;

                if (x.ResultCode == 100) {
                    this._uiHelper.CloseBarcodeCardModal();

                    if (this.IsBarcodeCard) {
                        this._uiHelper.SetCustomerQrStatus(true);
                    }

                    // window.postMessage({ command: 'cardinserted', message: x.CustomerIdEncrypt }, '*');

                    // this._coreService.customerUser.CustomerId = x.CustomerIdEncrypt;
                    this._coreService.CustomerCardBalance2(x.CustomerIdEncrypt);

                    this.OpenTransactionModal();
                }
            });
        }

        this.Input_1_Value = '';
        this.Input_2_Value = '';
    }

    public ProcCustomerBarcodeSearchTerminalResult(barcode) {
        this.tournamentsService.ProcCustomerBarcodeSearchTerminalResult(barcode).then((x: any) => {
            this.ResultCode = x.ResultCode;
            this.ResultMessage = x.ResultMessage;
        });
    }

    OpenTransactionModal() {
        let thiss = this;
        $('#Transactions_Modal')
            .modal({
                closable: false,
                onShow: function() {
                    // console.log('Transactions_Modal_SHOW');
                    thiss._uiHelper.SetTransactionModal(true);
                },

                onHidden: function() {
                    // console.log('Transactions_Modal_HIDE');
                    thiss._uiHelper.SetTransactionModal(false);
                },
            })
            .modal('show');
    }
}
